export default "../images/stackloans-partners-with-OppLoans_New_PORTAL_US.png?faee4a83a6c5862e30a74b365f5fa282";